import { Button, useModalContext } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

export const ModalCancelButton: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const { onClose } = useModalContext();
  return (
    <Button colorScheme="secondary" onClick={onClose}>
      {t("common:cancel")}
    </Button>
  );
};
